// eslint-disable-next-line import/prefer-default-export
import { fieldTypes } from '../layout/CommonLayout/CustomFormItem/constants';

export const prepareAttributesStructure = (attributes, attributeToValue) => {
  const result = [];

  Object.entries(attributeToValue).forEach(([key, value]) => {
    const { uuid, isRequiredTemplate } = attributes.find(({ code }) => key === code);

    if (Array.isArray(value) && value.length) {
      value.forEach(val => result.push({ uuid, is_required: isRequiredTemplate, value: val }));
    } else if (Array.isArray(value) && !value.length) {
      result.push({ uuid, is_required: isRequiredTemplate, value: null });
    } else {
      result.push({ uuid, is_required: isRequiredTemplate, value });
    }
  });

  return result;
};

export const buildAssignedAttributes = (attributes) => {
  const assignedAttributeOptions = {};

  const attributeValues = attributes.reduce((memo, attribute) => {
    const option = { value: attribute.selected.key, label: attribute.selected.value };

    if (memo[attribute.code]) {
      if (Array.isArray(memo[attribute.code])) {
        memo[attribute.code].push(attribute.selected.key);
      } else {
        memo[attribute.code] = [memo[attribute.code], attribute.selected.key];
      }

      assignedAttributeOptions[attribute.code].push(option);
    } else {
      if (attribute.selected.key) {
        memo[attribute.code] =
            attribute.attribute_field_type === fieldTypes.CHECKBOX
              ? [attribute.selected.key]
              : attribute.selected.key;
        assignedAttributeOptions[attribute.code] = [option];
      } else {
        memo[attribute.code] = attribute.selected.value;
      }
    }

    return memo;
  }, {});

  return [attributeValues, assignedAttributeOptions];
};
